#import "../fragments/lead-recent.graphql"

query GetRecentLeads($limit: Int) {
    search(type: LEAD, limit: $limit) {
        quickResults {
            recentResultsByType {
                leads {
                    ...LeadRecent
                }
            }
        }
    }
}
